/**
 * Reverses validator.escape() — handles exactly the entities that library produces.
 * Not a general-purpose HTML entity decoder. Do not use on untrusted HTML markup.
 */
export function decodeHtmlEntities(str: string): string {
  return str
    .replace(/&amp;/g, '&')
    .replace(/&#x2F;/gi, '/')
    .replace(/&#47;/g, '/')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&#x27;/gi, "'");
}

/**
 * Iteratively decodes HTML entities (handles double-encoding from chained sanitizers).
 */
export function decodeHtmlEntitiesIteratively(str: string, maxPasses = 5): string {
  let prev = '';
  let current = str;
  let guard = 0;
  while (current !== prev && guard < maxPasses) {
    prev = current;
    current = decodeHtmlEntities(current);
    guard += 1;
  }
  return current;
}
